import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","width":"100%"} }

import { toRefs, ref, watchEffect } from 'vue';
import { BaseDatePicker, BaseCheckbox } from 'xrk-components';
import { formatter } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'base-datepicker-longterm',
  props: {
    shortcuts: { default: [
      {
        text: '半年',
        value: () => {
          const end = new Date();
          const start = new Date();
          end.setMonth(start.getMonth() + 6);
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 0);
          return [start, end];
        }
      },
      {
        text: '一年',
        value: () => {
          const end = new Date();
          const start = new Date();
          end.setMonth(start.getMonth() + 12);
          start.setHours(0, 0, 0, 0);
          end.setHours(23, 59, 59, 0);
          return [start, end];
        }
      }
    ] },
    value: {},
    type: { default: 'daterange' },
    disabled: { type: Boolean }
  },
  emits: ['update:value'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { value, type } = toRefs(props);

const dateValue = ref<string | Array<string>>('');
const isLongterm = ref(false);

const checkIsLongterm = val => {
  if (val === '长期') {
    isLongterm.value = true;
    return true;
  }
  isLongterm.value = false;
  return false;
};

watchEffect(() => {
  const isRange = Array.isArray(value.value);
  checkIsLongterm(isRange ? value.value[1] : value.value);
  if (isRange) {
    if (checkIsLongterm) {
      dateValue.value = [];
    }
    dateValue.value = (value.value as Array<any>).map(
      item => item ?? formatter.date(item)
    );
  } else {
    if (checkIsLongterm) {
      dateValue.value = '';
    }
    dateValue.value = value.value ?? formatter.date(value.value as string);
  }
});

const onSelectChange = (e: any) => {
  if (e) {
    emit(
      'update:value',
      type.value === 'daterange' ? ['长期', '长期'] : '长期'
    );
  } else {
    emit('update:value', null);
  }
};

const onDateChange = val => {
  emit('update:value', val);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseDatePicker), _mergeProps({
      style: {"flex":"1"},
      onChange: onDateChange,
      modelValue: dateValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateValue).value = $event))
    }, _ctx.$attrs, {
      type: _unref(type),
      shortcuts: _unref(type) === 'daterange' ? _ctx.shortcuts : [],
      disabled: _ctx.disabled || isLongterm.value
    }), null, 16, ["modelValue", "type", "shortcuts", "disabled"]),
    _createVNode(_unref(BaseCheckbox), {
      style: {"flex-shrink":"0","margin-left":"10px"},
      disabled: _ctx.disabled,
      modelValue: isLongterm.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isLongterm).value = $event)),
      onChange: onSelectChange
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 长期有效 ")
      ]),
      _: 1
    }, 8, ["disabled", "modelValue"])
  ]))
}
}

})